import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import ThemeContext from '../../../../Context/theme/ThemeContext'

const OfferSuccess = () => {
    const navigate = useNavigate()
    const{theme}=useContext(ThemeContext)

    return (
        <div className='flex items-center font-pop flex-col'>
            <div className={`  rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[40%] flex flex-col gap-4
              ${theme==="dark"?"bg-black text-white":"bg-white"}`}>
                <div className="flex flex-col items-center gap-4">

                    <img src="../../Assets/Prop/OfferSuccess.png" alt="" className='w-64' />

                    <p className='text-center max-w-sm'>You have created the offer! Wait for confirmation from the recipient.</p>

                    <button
                        className={`my-4 w-full px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-medium hover:text-black font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full  text-white  *: ${theme==="dark"? "hover:text-white" :" hover:text-black"}`}
                        onClick={() => { navigate("/user-dashboard/") }}
                    >
                        Back to Dashboard
                    </button>
                </div>
            </div>
        </div>
    )
}

export default OfferSuccess